<template>
  <a-modal
    :title="tit"
    :visible="isLimitDialogShow"
    :ok-text="okTTxt"
    :cancel-text="cancelTxt"
    :width="isEnglish ? '662px' : '562px'"
    :destroy-on-close="true"
    :mask-closable="false"
    :confirm-loading="confirmLoading"
    class="add-alloicat-modal"
    @ok="formHandle"
    @cancel="cancelHanler"
  >
    <div
      v-if="isTipShow"
      class="sub-tip"
    >
      <i class="iconfont iconicon-test68" />
      {{ tipMessage }}
    </div>
    <div class="add-all-rule scroll_bar_beautify_ff">
      <a-form
        ref="createForm"
        :form="form"
        class="form"
        :class="{'en-add-form': isEnglish}"
        layout="inline"
      >
        <div class="module-row">
          <div class="module-cell-tit">
            <span>{{ $t('message["1446"]') }}</span>
          </div>
          <div
            v-for="item in editSelectedDatas"
            :key="item.id"
          >
            <template>
              <template v-if="item.fieldtype === 'area'">
                <area-a
                  :data="item"
                  :placeholder="selectPlaceholder"
                />
              </template>
              <template v-else>
                <type-select :item="item" />
              </template>
            </template>
          </div>
        </div>
        <div class="module-row module-row2">
          <div class="module-cell-tit">
            <span>{{ $t('message["298"]') }}</span>
          </div>
          <!-- <follow-cas :data="data" /> -->
          <a-form-item :label="`${followTitTxt}：`">
            <a-cascader
              v-decorator="['value',
                            {
                              initialValue: defaultArr,
                              rules: [
                                { type: 'array', required: true, message: followupplace },
                              ],
                            },]"
              :options="currentDevelopDatas2"
              class="dev-choose-list"
              :placeholder="followupplace"
              @change="onChange"
            />
          </a-form-item>
        </div>
      </a-form>
    </div>
  </a-modal>
</template>
<script>
import { mapActions, mapState, mapGetters, mapMutations } from 'vuex'
import TypeSelect from './TypeSelect'
import { getLang } from '@/lib/storage'
// import FollowCas from '@/components/pc/config/allocationrule/FollowCas'
import AreaA from './Area'
export default {
  components: {
    TypeSelect,
    AreaA
  },
  props: {
    itemData: {
      type: Object,
      default () {
      }
    },
    type: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      submiting: false,
      isLimitDialogShow: false,
      confirmLoading: false,
      form: this.$form.createForm(this),
      isTipShow: false,
      tipMessage: this.$t('message["159"]'),
      filterData: {}
      // data: {
      //   fieldname: '分配给',
      //   child: [],
      //   fieldkey: 'follow',
      //   isneeded: 1,
      //   info: {
      //     userid: this.itemData.userid || 0,
      //     groupid: this.itemData.groupid || 0,
      //     roleid: this.itemData.roleid || 0
      //   }
      // }
    }
  },
  provide () {
    return {
      myForm: this.form
    }
  },
  computed: {
    ...mapState('config/allocationrule', ['selectedDatas']),
    ...mapGetters('config/allocationrule', ['editSelectedDatas', 'currentDevelopDatas2']),
    objValues () {
      const { editSelectedDatas } = this
      let obj = {}
      editSelectedDatas.forEach(item => {
        // obj[item.fieldkey] = item.defaultValue
        this.$set(obj, item.fieldkey, item.defaultValue)
      })
      return obj
    },
    defaultValues () {
      const { itemData = {}, editSelectedDatas = [] } = this
      if (itemData['assign_rule']) {
        for (let key in itemData['assign_rule']) {
          editSelectedDatas.forEach(item => {
            // if (Object.keys(item).indexOf('defaultValue') > -1) {
            //   delete item.fieldValue
            // }
            if (key === item.fieldkey) {
              item.defaultValue = itemData['assign_rule'][key]
              if (item.fieldtype === 'area') {
                item.fieldvalue = itemData['assign_rule'][key]
              }
            }
          })
        }
      }
      return editSelectedDatas
    },
    // data () {
    //   const { roleid = 0, userid = 0, groupid = 0 } = this.itemData
    //   return {
    //     fieldname: '跟进人员',
    //     child: [],
    //     fieldkey: 'follow',
    //     isneeded: 1,
    //     info: {
    //       roleid,
    //       userid,
    //       groupid
    //     }
    //   }
    // },
    defaultArr () {
      const { roleid = 0, userid = 0, groupid = 0, status = 0 } = this.itemData
      let arr = []
      if (status) {
        if (roleid) {
          arr.push('roleid-' + roleid)
        }
        if (groupid) {
          arr.push('groupid-' + groupid)
        }
        if (this.itemData['divide_type'] === 1 && userid && (this.len > 1)) {
          arr.push('divide_type-' + this.itemData['divide_type'])
          arr.push('userid-' + userid)
        } else if (userid && !this.itemData['divide_type']) {
          arr.push('userid-' + userid)
        } else if (!userid && this.itemData['divide_type']) {
          arr.push('divide_type-' + this.itemData['divide_type'])
        } else if (this.itemData['divide_type'] === 1 && userid && (this.len === 1)) {
          arr.push('userid-' + userid)
        }
      } else {
        arr = []
      }

      return arr
    },
    tit () {
      const { type } = this
      return type === 'edit' ? this.$t('message["1391"]') : this.$t('message["1193"]')
    },
    len () {
      const { currentDevelopDatas2, itemData } = this
      const { groupid = 0 } = itemData
      let len = 0
      currentDevelopDatas2.forEach(item => {
        if (item.children && item.children.length) {
          item.children.forEach(item2 => {
            if (item2.value === 'groupid-' + groupid) {
              if (item2.divide_type && item2.divide_type.length) {
                len = item2.divide_type.length
              }
            }
          })
        }
      })
      return len
    },
    followTitTxt () {
      return this.$t('message["373"]')
    },
    followupplace () {
      return this.$t('message["863"]')
    },
    selectPlaceholder () {
      return this.$t('message["855"]')
    },
    cancelTxt () {
      return this.$t('message["896"]')
    },
    okTTxt () {
      return this.$t('message["926"]')
    },
    isEnglish () {
      return this.getLang() === 'en'
    }
  },
  watch: {
    isLimitDialogShow (val) {
      if (val) {
        const { roleid = 0, userid = 0, groupid = 0 } = this.itemData
        const { filterData } = this
        if (roleid) {
          filterData['roleid'] = roleid
        }
        if (userid) {
          filterData['userid'] = userid
        }
        if (groupid) {
          filterData['groupid'] = groupid
        }
        if (this.itemData['divide_type']) {
          filterData['divide_type'] = this.itemData['divide_type']
        }
      }
    }
  },
  mounted () {
  },
  inject: ['reload'],
  methods: {
    ...mapActions('config/allocationrule', ['editAllocation']),
    ...mapMutations('config/allocationrule', ['setActiveName']),
    getLang,
    changeVisible (isShow) {
      this.isLimitDialogShow = isShow
    },
    formHandle () {
      this.form.validateFieldsAndScroll(async (err, values) => {
        if (!err) {
          const { editSelectedDatas } = this
          let objAssgin = {}
          if (!Object.keys(this.filterData).includes('divide_type')) {
            this.filterData['divide_type'] = this.itemData.divide_type
          }
          let obj = this.filterData
          editSelectedDatas.forEach(item => {
            // obj[item.fieldkey] = item.defaultValue
            this.$set(objAssgin, item.fieldkey, item.defaultValue)
          })
          obj['assign_rule'] = objAssgin
          obj['id'] = this.itemData.id || 0
          const chain = await this.editAllocation()
          chain.params(obj)
            .setForm(this.form)
            .onSuccess(raw => {
              this.$message.success(this.$t('message["81"]'))
              this.form.resetFields()
              this.isLimitDialogShow = false
              this.reload()
              this.setActiveName('setrule')
            })
            .onNetSuccess(raw => {
              let res = raw.data
              if (res.error) {
                this.isTipShow = true
                this.tipMessage = res.message
              }
            })
            .fetch()
        }
      })
    },
    onChange (val, n) {
      // console.log(n)
      let obj = {}
      let newObj = {}
      if (val.length) {
        n.forEach((item) => {
          const key = item.keyname
          newObj[key] = item.id
          obj = Object.assign(obj, newObj)
        })
      }
      this.filterData = obj
    },
    cancelHanler () {
      this.isLimitDialogShow = false
      this.isTipShow = false
    },
    getValue (item, val) {
      console.log(val)
    }
  }
}
</script>
<style lang="scss" scoped>
.add-all-rule::v-deep {
  max-height: 366px;
  overflow-y: auto;
  margin-right: -10px;
  .ant-form-inline .ant-form-item {
    margin-bottom: 24px;
    display: block;
  }
  .ant-row:after {
    clear: both;
    content: '.';
    display: block;
    height: 0;
    visibility: hidden;
  }
  .ant-row {
    padding-left: 94px;
    .ant-input-number {
      width: 160px;
    }
    .ant-form-item-label {
      float: left;
      width: 94px;
      margin-left: -94px;
      label {
        color: #666;
      }
    }
    .ant-form-item-control-wrapper {
      float: left;
      width: 100%;
    }
  }
  .module-row {
    padding-left: 68px;
    position: relative;
    .module-cell-tit {
      position: absolute;
      left: 0;
      span {
        height: 30px;
        line-height: 30px;
        border-radius: 4px;
        font-size: 14px;
        background: #f5f5f5;
        border: 1px solid #ebebeb;
        display: inline-block;
        padding: 0 12px;
      }
    }
  }
  .module-row2 {
    border-top: 1px dashed #d6d6d6;
    padding-top: 24px;
    margin-top: 24px;
  }
}
.sub-tip {
  width: 562px;
  height: 40px;
  background: #fdeaea;
  border: 1px solid #f68585;
  margin: -40px -40px 24px;
  border-left: none;
  border-right: none;
  line-height: 40px;
  padding: 0 16px;
  i {
    font-size: 16px;
    color: #f67070;
  }
}
.en-add-form::v-deep {
   .ant-row {
    padding-left: 194px;
    .ant-form-item-label {
      width: 194px;
      margin-left: -194px;
    }
  }
}
</style>
<style lang="scss">
.add-alloicat-modal {
  .ant-modal-body {
    padding: 40px 40px 16px;
  }
}
</style>
